import React, { createContext, useContext, useState } from "react";

const UserModalContext = createContext();

export const useUserModal = () => {
  const context = useContext(UserModalContext);
  if (!context) {
    throw new Error("useUserModal must be used within UserModalProvider");
  }
  return context;
};

export const UserModalProvider = ({ children }) => {
  const [certificateApplicationModal, setCertificateApplicationModal] = useState({
    isOpen: false,
    courseId: null,
    courseName: null,
  });

  const openCertificateApplicationModal = (courseId, courseName) => {
    setCertificateApplicationModal({
      isOpen: true,
      courseId,
      courseName,
    });
  };

  const closeCertificateApplicationModal = () => {
    setCertificateApplicationModal({
      isOpen: false,
      courseId: null,
      courseName: null,
    });
  };

  const value = {
    certificateApplicationModal,
    openCertificateApplicationModal,
    closeCertificateApplicationModal,
  };

  return (
    <UserModalContext.Provider value={value}>
      {children}
    </UserModalContext.Provider>
  );
};